import { IICTServiceState } from './types';

const initialICTServiceState = (): IICTServiceState => ({
  loading: false,
  selectedContractForICT: null,
  selectedFunctionForICT: null,
  selectedTPPForICT: null,
  selectedEntityForICT: null,
  contractRefNumber: '',
  selectedTPP_Multi: [],
});

export default initialICTServiceState;
